import i18n from "../../../../../../constants/i18n";
import { ONE_O_ONE_M_FILTER } from "../../../../../../constants/picker-entries-constants";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Picker from "../../../../../../core/et3-input/et3-picker";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getKhattabatFilterstore from "../../../../../../stores/khattabat-stores/filter-store";
import getKhattabatSelectsStore from "../../../../../../stores/khattabat-stores/selects-store";
import { TEt3PickerMultipleValue } from "../../../../../../TypesNEW";
import ApplyButton from "./ApplyButton";
import Title from "./Title";

const Filter = withLiteObserverAndTheme(() => {
  return (
    <ET3Div
      width={1510}
      height={150}
      alignItems={"space-between"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"flex-start"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Title />
      <Et3Margin top={10} bottom={10} left={0} right={0} />
      <ET3Div
        width={1510}
        height={100}
        alignItems={"flex-start"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"space-between"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("FILTERS")}
          options={ONE_O_ONE_M_FILTER}
          value={getKhattabatFilterstore().filter1o1MSelectedTypes.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatSelectsStore().initializeAndClearMarksStateWithClients(
              "matchResultPage"
            );
            getKhattabatFilterstore().setFilterSelected101MTypes(value);
          }}
          isMultiple={true}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <ApplyButton />
      </ET3Div>
    </ET3Div>
  );
});

export default Filter;
